/** Default Vendure shipping method code when none is selected. */
export const DEFAULT_SHIPPING_CODE = "standard"

/** Default Nomin stock-location pkey (ESHOP). */
export const DEFAULT_NOMIN_PKEY = "2007122500001"

export const ASSETS_BASE_URL = "https://assets.nomin.mn/"

export const ULAANBAATAR_TIMEZONE = "Asia/Ulaanbaatar"

export type TimeWindow = {
  /** Minutes from midnight in Asia/Ulaanbaatar. */
  start: number
  /** Minutes from midnight in Asia/Ulaanbaatar. */
  end: number
}

export type EnabledHoursObject = {
  start?: string
  from?: string
  startTime?: string
  end?: string
  to?: string
  endTime?: string
}

export type EnabledHoursInput =
  | string
  | EnabledHoursObject
  | Array<string | EnabledHoursObject>
  | null
  | undefined

export type HeaderShippingMethod = {
  code: string
  title: string
  icon: string
  description: string
  color: string
  textColor: string
  borderColor: string
  bgImage: string
  background: string
  dialogImage: string
  dialogTitle: string
  dialogDescription: string
  enabledHours: EnabledHoursInput
  disabledImage: string
  disabledGif: string
  disabledText: string
  disabledTitle: string
}

export type SavedShippingAddress = {
  addressId: string
  shippingMethodCode: string
  fullName: string
  streetLine1: string
  streetLine2: string
  city: string
  province: string
  phoneNumber: string
  latitude: number | null
  longitude: number | null
  branch: string
  countryCode: string
  storeType: string
  locationCode: string
  stockLocationId: string
}

export type StockLocation = {
  id: string
  name: string
  customFields?: {
    nominPkey?: string | null
  }
}

export type CoverageKhoroo = {
  name: string
  stockLocationId: string
}

export type CoverageDistrict = {
  district: string
  khoroos: CoverageKhoroo[]
}

export type AddressDeps = {
  coverage: CoverageDistrict[]
  stockLocations: StockLocation[]
}
